export default {
  init: function() {
    return {
      pageSize: 10,
      pageNumber: 1,
      totalCount: 0,
      skip: 0,
      styleClass: [],
      showCtrl: true,
      pageSizeSelector: false,
      handlePageSizeChange: null,
      pageCount: function () {
        const pageCount = parseInt(this.totalCount / this.pageSize);
        if (this.totalCount % this.pageSize == 0) {
          return pageCount;
        } else {
          return pageCount + 1;
        }
      },
      func: function () {
        return false;
      },
      execute: function () {
        this.func();
      },
      bind: function (func) {
        this.func = func;
        return this;
      },
      next: function () {
        if (this.pageNumber >= this.pageCount()) {
          return;
        }
        this.pageNumber++;
        this.skip = (this.pageNumber - 1) * this.pageSize;
        this.execute();
      },
      pre: function () {
        if (this.pageNumber <= 1) {
          return;
        }
        this.pageNumber--;
        this.skip = (this.pageNumber - 1) * this.pageSize;
        this.execute();
      },
      first: function () {
        if (this.pageNumber <= 1) {
          return;
        }
        this.pageNumber = 1;
        this.skip = (this.pageNumber - 1) * this.pageSize;
        this.execute();
      },
      last: function () {
        if (this.pageNumber >= this.pageCount()) {
          return;
        }
        this.pageNumber = this.pageCount();
        this.skip = (this.pageNumber - 1) * this.pageSize;
        this.execute();
      },
      reload: function () {
        this.execute();
      },
      setTotalCount: function (totalCount) {
        this.totalCount = totalCount;
        // 修正当前页
        if (this.pageNumber > this.pageCount()) {
          this.pageNumber = this.pageCount();
        }
        if (this.pageNumber == 0) {
          this.pageNumber = 1;
        }
      },
      init: function () {
        this.pageNumber = 1;
        this.totalCount = 0;
        this.skip = 0;
      },
      goTo: function (pageNumber) {
        if (pageNumber) {
          this.pageNumber = pageNumber;
          if (this.pageNumber > this.pageCount()) {
            this.pageNumber = this.pageCount();
          } else if (this.pageNumber < 1) {
            this.pageNumber = 1;
          }
          this.skip = (this.pageNumber - 1) * this.pageSize;
          this.execute();
        }
      },
      isFirst: function () {
        return this.pageNumber <= 1 ? true : false;
      },
      isLast: function () {
        return this.pageNumber >= this.pageCount() ? true : false;
      },
      setPageNumber(pageNumber) {
        this.pageNumber = pageNumber;
        this.skip = (this.pageNumber - 1) * this.pageSize;
      },
      getSkip: function () {
        return (this.pageNumber - 1) * this.pageSize;
      },
      getPageSize() {
        return this.pageSize;
      },
      getPageNumber() {
        return this.pageNumber;
      },
      setPageSize: function (pageSize) {
        this.pageSize = pageSize;
        this.skip = (this.pageNumber - 1) * this.pageSize;
      },
      pageSizeChange: function (pageSize) {
        this.setPageSize(pageSize);
        this.reload();
        if (this.handlePageSizeChange) {
          this.handlePageSizeChange(pageSize);
        }
      },
      setHandlePageSizeChange: function (handlePageSizeChange) {
        this.handlePageSizeChange = handlePageSizeChange;
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/page.js